import { render, staticRenderFns } from "./Puff.vue?vue&type=template&id=0285519a&"
import script from "./Puff.vue?vue&type=script&lang=ts&"
export * from "./Puff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports